/**
 * Star / unstar a collection (see starredCollection.js). Filled indigo when
 * starred: the star is a selection, so it takes the selection colour.
 */
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { mvkgTokens } from '../../theme/mvkgTokens';
import { useStarredCollection, toggleStar, STAR_UNSUPPORTED } from './starredCollection';

export default function StarToggle({ collection, size = 28, sx }) {
  const { id, supported, busy } = useStarredCollection();
  if (!collection) return null;
  const on = id === Number(collection.id);
  const title = !supported
    ? STAR_UNSUPPORTED
    : on
      ? `Starred: Home recommends from ${collection.name}. Click to unstar.`
      : `Star ${collection.name}: Home will recommend from it`;
  return (
    <Tooltip title={title} arrow>
      <span style={{ display: 'inline-flex' }}>
        <IconButton
          aria-label={on ? `Unstar ${collection.name}` : `Star ${collection.name}`}
          aria-pressed={on}
          disabled={!supported || busy || id === undefined}
          onClick={(e) => { e.stopPropagation(); toggleStar(collection); }}
          sx={{
            width: size, height: size, borderRadius: '8px',
            color: on ? mvkgTokens.brand.main : 'rgba(15,23,42,0.45)',
            '&:hover': { bgcolor: 'rgba(15,23,42,0.05)', color: mvkgTokens.brand.main },
            '&:focus-visible': { outline: `2px solid ${mvkgTokens.brand.main}`, outlineOffset: 2 },
            ...sx,
          }}
        >
          {on ? <StarIcon sx={{ fontSize: 18 }} /> : <StarBorderIcon sx={{ fontSize: 18 }} />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
